import request from "@/utils/request";

export function getSms(data) {
  return request({
    url: "/consumer/auth/sendSms",
    method: "post",
    data
  });
}

export function login(data) {
  return request({
    url: "/consumer/commonLogin/login",
    method: "post",
    data
  });
}

/**
 * 信息保存
 * @param {*} data
 * @returns
 */
// export function updatePersonalInfo(data) {
//   return request({
//     url: "/consumer/staff",
//     method: "post",
//     data
//   });
// }

export function updatePersonalInfo(data) {
  return request({
    url: "/consumer/staff/V2",
    method: "post",
    data
  });
}

export function getUserInfo() {
  return request({
    url: "/consumer/commonStaff/info",
    method: "get"
  });
}

export function realNameAuth(data) {
  return request({
    url: "/consumer/auth/realNameAuthentication",
    method: "post",
    data
  });
}

export function getUserInfoByKey() {
  return request({
    url: `/consumer/staff`,
    method: "get"
  });
}

export function pay() {
  return request({
    url: "/pay/notify",
    method: "post"
    // data
  });
}

export function realNameAuthenticationResultCheck() {
  return request({
    url: "/consumer/auth/realNameAuthenticationResultCheck",
    method: "get"
  });
}

export function updateWithDataId(data) {
  return request({
    url: "/consumer/staff/updateWithDataId",
    method: "put",
    data: data
  });
}

export function deleteInfo(data) {
  return request({
    url: "/consumer/staff/delete",
    method: "post",
    data: data
  });
}

export function reportSave(data) {
  return request({
    url: "/consumer/report/save",
    method: "post",
    data: data
  });
}

export function dataRecord(id) {
  return request({
    url: `/consumer/staff/dataRecord?id=${id}`,
    method: "get"
  });
}

export function firstWritePromise() {
  return request({
    url: `/consumer/commonStaff/firstWritePromise`,
    method: "get"
  });
}
// 红点已读
export function redDotMarkDeal(id) {
  return request({
    url: `/consumer/staff/redDotMarkDeal?dataId=${id}`,
    method: "get"
  });
}


// 机构认证申请
export function agencyApply(data) {
  return request({
    url: `/consumer/staff/businessNameAuthenticationApply`,
    method: "post",
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/user.js